<template>
  <div>
    <view-quiz @close="executeQuiz=false;" v-if="executeQuiz" :moduleId="selectedModuleId" />
    <section class="lms-container">
      <div class="content">
        <div class="breadcrumb" style="border: none !important;"></div>

        <ul v-if="quizList.length > 0" class="exams-list">
          <li v-for="q in quizList" :key="q.id" class="has-answered custom-shadow">
            <div class="exam-info-bar">
              <span class="exam-title">{{q.title}}</span>
              <span class="exam-grade">{{q.moduleName}}</span>
              <span class="exam-grade-number">{{q.grade}}%</span>
              <p></p>

              <quiz-button class="primary" :loading="false" @click="openQuizModal(q)">visualizar</quiz-button>
            </div>
          </li>
        </ul>

        <div v-else>
          <div class="placeholder-message">
            <h5>Nenhuma avaliação realizada</h5>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import axios from "axios";
import QuizButton from "../../Buttons/QuizButton";
import ViewQuiz from "./ViewQuiz";

export default {
  data() {
    return {
      selectedModuleId: 0,
      executeQuiz: false,
      changedAnswer: 0,
      savingAnswer: 0,
      savingQuestion: false,
      userType: this.$store.getters.user.type,
      quizList: []
    };
  },
  components: {
    QuizButton,
    ViewQuiz
  },
  methods: {
    openQuizModal(quiz) {
      this.selectedModuleId = quiz.moduleId;
      this.executeQuiz = true;
    },
    getQuestions() {
      const path = this.$global.endpoint + "/quiz/execution/getall";
      axios
        .post(path, {})
        .then(res => {
          this.quizList = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    this.getQuestions();
  }
};
</script>
